var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        { staticClass: "mb-4" },
        [
          _c(
            "div",
            { staticClass: "flex justify-between items-center mb-3" },
            [
              _c("div", [
                _c("h4", { staticClass: "mb-0" }, [
                  _vm._v(_vm._s(_vm.$t("fee_plans.current_plan"))),
                ]),
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v(_vm._s(_vm.$t("fee_plans.current_plan_hint"))),
                ]),
              ]),
              _vm.current && _vm.current.is_default
                ? _c(
                    "vs-chip",
                    { staticClass: "text-base", attrs: { color: "primary" } },
                    [_vm._v(" " + _vm._s(_vm.$t("fee_plans.default")) + " ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.current && _vm.current.plan
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "mb-2" }, [
                    _c("span", { staticClass: "font-semibold" }, [
                      _vm._v(_vm._s(_vm.current.plan.name)),
                    ]),
                    _vm.current.active_version
                      ? _c("small", { staticClass: "text-muted ml-2" }, [
                          _vm._v(
                            " v" +
                              _vm._s(_vm.current.active_version.version) +
                              " · " +
                              _vm._s(
                                _vm.$t("fee_plans.effective_since", {
                                  date: _vm.$utils.format.date(
                                    _vm.current.active_version.effective_from
                                  ),
                                })
                              ) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm.current.active_version
                    ? _c(
                        "table",
                        {
                          staticClass: "w-full mb-2",
                          staticStyle: { "font-size": ".9rem" },
                        },
                        [
                          _c("thead", [
                            _c("tr", { staticClass: "text-left text-muted" }, [
                              _c("th", { staticClass: "pb-1" }, [
                                _vm._v(_vm._s(_vm.$t("fee_plans.scope"))),
                              ]),
                              _c("th", { staticClass: "pb-1" }, [
                                _vm._v(_vm._s(_vm.$t("fee_plans.rate"))),
                              ]),
                            ]),
                          ]),
                          _c(
                            "tbody",
                            _vm._l(
                              _vm.current.active_version.rules,
                              function (rule) {
                                return _c(
                                  "tr",
                                  { key: rule.id, staticClass: "border-top" },
                                  [
                                    _c("td", { staticClass: "py-1" }, [
                                      _vm._v(_vm._s(_vm.ruleScopeLabel(rule))),
                                    ]),
                                    _c(
                                      "td",
                                      { staticClass: "py-1" },
                                      [
                                        rule.pricing_mode === "FLAT"
                                          ? [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.rateLabel(
                                                      rule.fee_percent,
                                                      rule.fee_fixed_cents
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          : _vm._l(rule.tiers, function (tier) {
                                              return _c(
                                                "div",
                                                { key: tier.id },
                                                [
                                                  _c("small", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.tierThresholdLabel(
                                                            tier
                                                          )
                                                        ) +
                                                        " → " +
                                                        _vm._s(
                                                          _vm.rateLabel(
                                                            tier.fee_percent,
                                                            tier.fee_fixed_cents
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            }),
                                      ],
                                      2
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      )
                    : _c(
                        "b-alert",
                        {
                          staticClass: "p-1",
                          attrs: { show: "", variant: "warning" },
                        },
                        [
                          _c("small", [
                            _vm._v(
                              _vm._s(_vm.$t("fee_plans.no_active_version"))
                            ),
                          ]),
                        ]
                      ),
                ],
                1
              )
            : _vm.loaded
            ? _c(
                "b-alert",
                { staticClass: "p-1", attrs: { show: "", variant: "warning" } },
                [_c("small", [_vm._v(_vm._s(_vm.$t("fee_plans.no_plan")))])]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.canAssign
        ? _c("vx-card", { staticClass: "mb-4" }, [
            _c("h4", { staticClass: "mb-3" }, [
              _vm._v(_vm._s(_vm.$t("fee_plans.assign_title"))),
            ]),
            _c("div", { staticClass: "vx-row items-end" }, [
              _c(
                "div",
                { staticClass: "vx-col sm:w-5/12 w-full" },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("fee_plans.plan"),
                        "label-size": "sm",
                      },
                    },
                    [
                      _c("b-form-select", {
                        attrs: { options: _vm.planOptions, size: "sm" },
                        model: {
                          value: _vm.assignment.plan_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.assignment, "plan_id", $$v)
                          },
                          expression: "assignment.plan_id",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "vx-col sm:w-3/12 w-full" },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("fee_plans.effective_from"),
                        "label-size": "sm",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { type: "date", size: "sm" },
                        model: {
                          value: _vm.assignment.effective_from,
                          callback: function ($$v) {
                            _vm.$set(_vm.assignment, "effective_from", $$v)
                          },
                          expression: "assignment.effective_from",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "vx-col sm:w-4/12 w-full pb-1" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "primary",
                        size: "sm",
                        disabled: !_vm.assignment.plan_id,
                      },
                      on: { click: _vm.assign },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("fee_plans.assign")) + " ")]
                  ),
                ],
                1
              ),
            ]),
            _c("small", { staticClass: "text-muted" }, [
              _vm._v(_vm._s(_vm.$t("fee_plans.assign_hint"))),
            ]),
          ])
        : _vm._e(),
      _vm.current && _vm.current.history && _vm.current.history.length
        ? _c("vx-card", [
            _c("h4", { staticClass: "mb-3" }, [
              _vm._v(_vm._s(_vm.$t("fee_plans.history"))),
            ]),
            _c(
              "table",
              { staticClass: "w-full", staticStyle: { "font-size": ".9rem" } },
              [
                _c("thead", [
                  _c("tr", { staticClass: "text-left text-muted" }, [
                    _c("th", { staticClass: "pb-1" }, [
                      _vm._v(_vm._s(_vm.$t("fee_plans.plan"))),
                    ]),
                    _c("th", { staticClass: "pb-1" }, [
                      _vm._v(_vm._s(_vm.$t("fee_plans.effective_from"))),
                    ]),
                    _c("th", { staticClass: "pb-1" }, [
                      _vm._v(_vm._s(_vm.$t("fee_plans.notes"))),
                    ]),
                  ]),
                ]),
                _c(
                  "tbody",
                  _vm._l(_vm.current.history, function (item) {
                    return _c(
                      "tr",
                      { key: item.id, staticClass: "border-top" },
                      [
                        _c("td", { staticClass: "py-1" }, [
                          _vm._v(
                            _vm._s(item.plan ? item.plan.name : item.plan_id)
                          ),
                        ]),
                        _c("td", { staticClass: "py-1" }, [
                          _vm._v(
                            _vm._s(_vm.$utils.format.date(item.effective_from))
                          ),
                        ]),
                        _c("td", { staticClass: "py-1" }, [
                          _c("small", { staticClass: "text-muted" }, [
                            _vm._v(_vm._s(item.notes)),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }